import { connect } from 'react-redux';
import { settingsActions } from '../../../reducers/settings.reducer';
import Card from '../../common/card/Card.react';
import CardHeader from '../../common/card/CardHeader.react';
import CardBody from '../../common/card/CardBody.react';
import Table from '../../common/table/Table.react';
var FeatureFlagsCard = function FeatureFlagsCard(_ref) {
  var application = _ref.application,
    featureFlags = _ref.featureFlags,
    environmentConstants = _ref.environmentConstants,
    featureFlagConstants = _ref.featureFlagConstants,
    setFeatureFlagsAction = _ref.setFeatureFlagsAction;
  var getFlag = function getFlag(_ref2) {
    var clientEnv = _ref2.clientEnv,
      key = _ref2.key,
      clientApp = _ref2.clientApp;
    var value = false;
    featureFlags.forEach(function (x) {
      if (x.clientEnv === clientEnv && x.key === key && x.clientApp === clientApp) {
        value = x.value;
      }
    });
    return value;
  };
  var getTableData = function getTableData(_ref3) {
    var clientApp = _ref3.clientApp;
    return featureFlagConstants.filter(function (x) {
      return x.clientApp === clientApp;
    }).map(function (x) {
      var returnObj = {
        id: x['id'],
        flagName: x['name'],
        description: x['description'],
        key: x['key'],
        clientApp: clientApp
      };
      environmentConstants.map(function (y) {
        returnObj[y.value] = getFlag({
          clientEnv: y.key,
          key: x.key,
          clientApp: clientApp
        });
      });
      return returnObj;
    });
  };
  var columns = {
    'flagName': 'Flag Name',
    'description': 'Description'
  };
  environmentConstants.forEach(function (x) {
    columns[x.value] = {
      title: x.name,
      type: {
        label: 'boolean',
        true: 'Enabled',
        false: 'Disabled'
      },
      sort: false,
      onClick: function onClick(flag) {
        // TODO :: add confirm popup here
        setFeatureFlagsAction({
          id: flag.id,
          clientApp: application.value,
          clientEnv: x.value,
          key: flag.key,
          value: !flag[x.value]
        });
      }
    };
  });
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "".concat(application.name, " - Feature Flags")
  }), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(Table, {
    columns: columns,
    data: getTableData({
      clientApp: application.value
    })
  })));
};
var mstp = function mstp(s) {
  var _s$settings$constants, _s$settings$constants2;
  return {
    featureFlags: s.settings.featureFlags,
    environmentConstants: ((_s$settings$constants = s.settings.constants) === null || _s$settings$constants === void 0 ? void 0 : _s$settings$constants.environments) || [],
    featureFlagConstants: ((_s$settings$constants2 = s.settings.constants) === null || _s$settings$constants2 === void 0 ? void 0 : _s$settings$constants2.featureFlags) || []
  };
};
var mdtp = {
  setFeatureFlagsAction: settingsActions.setFeatureFlags
};
export default connect(mstp, mdtp)(FeatureFlagsCard);